'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('../utils/utils');

var _biLogger = require('@wix/photography-client-lib/dist/src/utils/biLogger');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullscreenSocialDownload = function (_React$Component) {
  (0, _inherits3.default)(FullscreenSocialDownload, _React$Component);

  function FullscreenSocialDownload(props) {
    (0, _classCallCheck3.default)(this, FullscreenSocialDownload);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FullscreenSocialDownload.__proto__ || (0, _getPrototypeOf2.default)(FullscreenSocialDownload)).call(this, props));

    _this.onKeyPress = _this.onKeyPress.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(FullscreenSocialDownload, [{
    key: 'onKeyPress',
    value: function onKeyPress(e, downloadLink) {
      switch (e.keyCode || e.charCode) {
        case 32: //space
        case 13:
          //enter
          e.preventDefault();
          if (_utils.utils.isiOS()) {
            window.open(downloadLink);
          } else {
            window.open(downloadLink, '_blank');
          }
          _biLogger.logger.track('download', { origin: 'fullscreen' });
          return false;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var arrowImageClass = 'progallery-svg-font-icons-download' + (_utils.utils.isStoreGallery() ? '-store' : '');
      var _props = this.props,
          layout = _props.layout,
          device = _props.device;

      var curItem = this.props.current.item;
      var downloadLink = curItem.download_url.mp4 || curItem.download_url.webm || curItem.download_url.img;
      var downloadClassNames = ['fullscreen-social-download ' + arrowImageClass, this.props.itemActions.viewClassName(layout, device), 'has-custom-focus'].join(' ') + (_utils.utils.isMobile ? ' pro-fullscreen-mobile-social-icon' : '');

      return this.props.styleParams.allowDownload && !curItem.isDemo ? curItem.isText ? _react2.default.createElement('a', {
        className: downloadClassNames,
        style: this.props.style,
        tabIndex: _utils.utils.getTabIndex('fullscreenDownload'),
        'aria-label': 'Download ' + curItem.type + ' to your device',
        role: 'button',
        onClick: function onClick(evt) {
          evt.stopPropagation();
          _this2.props.itemActions.downloadTextItem(curItem, 'fullscreen');
        }
      }) : _react2.default.createElement('a', {
        className: downloadClassNames,
        style: this.props.style,
        tabIndex: 0,
        'aria-label': 'Download ' + curItem.type + ' to your device',
        role: 'button',
        href: downloadLink,
        download: 'download',
        target: '_blank',
        onClick: function onClick(e) {
          e.preventDefault();
          if (_utils.utils.isiOS()) {
            window.open(downloadLink);
          } else {
            window.open(downloadLink, '_blank');
          }
          _biLogger.logger.track('download', { origin: 'fullscreen' });
        },
        onKeyDown: function onKeyDown(e) {
          return _this2.onKeyPress(e, downloadLink);
        }
      }) : false;
    }
  }]);
  return FullscreenSocialDownload;
}(_react2.default.Component);

exports.default = FullscreenSocialDownload;